import { useMemo } from 'react'
import useStateControls from '../../../../../hooks/useStateControls'
import { useModal } from '../../../../../hooks/useModal'
import { useSetBackground } from '../../../interactiveShop'
import { useOnboarding } from '../../../../../redux/reducer/content'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { image } from '../../../../../utils/data/baseUrl'
import { RAMADAN } from '../../../../../constants/events'

export default function useRamadanModal() {
  const { closeModal } = useModal()
  const { setState } = useStateControls()
  const setBackground = useSetBackground()
  const { eventModalsVisible } = useOnboarding()

  const now = new Date()
  const start = new Date('2026-02-24T12:00:00')
  const end = new Date('2026-03-18T23:59:59')
  const isPromoPeriod = now >= start && now <= end

  return useMemo(
    () =>
      eventModalsVisible &&
      isPromoPeriod && {
        id: 'ramadanModal',
        type: 'universalModal',
        event: RAMADAN,
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full', 'ramadan'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img: image('modals/ramadan.png'),
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: 'ramadanModal.title',
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: 'ramadanModal.description',
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: 'ramadanModal.button',
                        modalData: { action: 'close', data: { type: 'current' } },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      },
    [closeModal, setBackground, setState, eventModalsVisible],
  )
}
